import { Currency } from '@/core/currency/interfaces';

const EGP: Currency = {
    name: 'Egyptian Pound',
    demonym: 'Egyptian',
    majorSingle: 'Pound',
    majorPlural: 'Pounds',
    codeNumeric: '818',
    symbol: 'E£',
    symbolNative: 'ج.م.',
    minorSingle: 'Qirsh',
    minorPlural: 'Qirsh',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'EGP',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default EGP;
